/* eslint-disable array-callback-return */
import React from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import { connect } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'

function Comment(props) {
    let comment = props.comment

    return (
        <List>
            <ListItem>
                <ListItemText
                    primary={<IntlMessages id="operatorDescription" />}
                    secondary={comment.vComment} />
            </ListItem>
            <ListItem>
                <ListItemText
                    primary={<IntlMessages id="repairmanDescription" />}
                    secondary={comment.vRepairmanComment || ''} />
            </ListItem>
            <ListItem>
                <ListItemText
                    primary={<IntlMessages id="repairedParts" />}
                    secondary={comment.vRepairedParts || ''} />
            </ListItem>
            <ListItem>
                <ListItemText
                    primary={<IntlMessages id="replacementParts" />}
                    secondary={comment.vReplacementParts || ''} />
            </ListItem>
        </List>
    )
}

export default connect()(Comment)
